// Shared footer, used on the authenticated app shell (AppLayout) and the
// public Login page. `variant="dark"` is for use over a photo/gradient
// background (Login's left brand panel); "default" is for normal page flow.
export default function Footer({ variant = "default", className = "" }) {
  const dark = variant === "dark";
  return (
    <footer
      data-testid="app-footer"
      className={`shrink-0 py-4 px-6 text-center text-[11px] tracking-wide ${
        dark ? "text-white/50" : "text-muted-foreground border-t border-border"
      } ${className}`}
    >
      Developed by <span className={dark ? "text-white/70 font-medium" : "font-medium text-foreground/80"}>KaribuNet Limited</span>
      {" · "}All rights reserved{" · "}
      <span className="font-mono">v.1.0.0</span>
    </footer>
  );
}
